import React from 'react'
import { useIntl } from 'react-intl'
import { mdiAlertCircleOutline } from '@mdi/js'

import theme from 'theme_'
import { MdiIcon } from 'components/Icons'
import { ResentWrapper, TwoFaInputWrapper } from './styles'
import { loginMessages } from '../../messages'

import CommonButton from 'components/Button/CommonButton'
import LoginCommonLayout from '../LoginCommonLayout'
import { StyledMainHeading } from '../MainHeading/MainHeading'
import { StyledDescriptionText } from '../../styles'
import { ResentFailedProps } from '../../types'

export default function ResentFailed(props: ResentFailedProps) {
  const { formatMessage } = useIntl()

  const { setResentError, resend } = props

  return (
    <LoginCommonLayout>
      <StyledMainHeading>
        {formatMessage(loginMessages.resendFailedHeader)}
      </StyledMainHeading>
      <TwoFaInputWrapper>
        <MdiIcon
          path={mdiAlertCircleOutline}
          color={theme.colors.error}
          size={3}
        />
      </TwoFaInputWrapper>

      <StyledDescriptionText>
        {formatMessage(loginMessages.resendFailedError)}
      </StyledDescriptionText>

      <ResentWrapper>
        <CommonButton type="button" onClick={() => setResentError(false)}>
          {formatMessage(loginMessages.goToSignInButton)}
        </CommonButton>
        <CommonButton type="button" variant="primary" onClick={resend}>
          {formatMessage(loginMessages.tryAgainButton)}
        </CommonButton>
      </ResentWrapper>
    </LoginCommonLayout>
  )
}
